var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3868_188475",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3868_188475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.30775 15.5C2.83208 15.5 2.41192 15.3176 2.04725 14.9528C1.68242 14.5881 1.5 14.1679 1.5 13.6923V12.077C1.5 11.972 1.5135 11.8595 1.5405 11.7395C1.56733 11.6197 1.59742 11.5077 1.63075 11.4037L4.49675 4.64125C4.63992 4.32142 4.88008 4.05125 5.21725 3.83075C5.55442 3.61025 5.90625 3.5 6.27275 3.5H16.7885V15.5L10.9713 21.2673C10.7724 21.4659 10.5423 21.5845 10.2808 21.623C10.0193 21.6615 9.76867 21.6167 9.529 21.4885C9.28917 21.3602 9.1135 21.1781 9.002 20.9423C8.8905 20.7064 8.86675 20.4622 8.93075 20.2095L10.0078 15.5H3.30775ZM15.2885 14.8615V5H6.26925C6.19875 5 6.12667 5.01925 6.053 5.05775C5.97917 5.09625 5.923 5.16033 5.8845 5.25L3 12V13.6923C3 13.7821 3.02883 13.8558 3.0865 13.9135C3.14417 13.9712 3.21792 14 3.30775 14H11.9038L10.65 19.4808L15.2885 14.8615ZM19.6923 3.5C20.1894 3.5 20.615 3.677 20.969 4.031C21.323 4.385 21.5 4.81058 21.5 5.30775V13.6923C21.5 14.1894 21.323 14.615 20.969 14.969C20.615 15.323 20.1894 15.5 19.6923 15.5H16.7885V14H19.6923C19.7821 14 19.8558 13.9712 19.9135 13.9135C19.9712 13.8558 20 13.7821 20 13.6923V5.30775C20 5.21792 19.9712 5.14417 19.9135 5.0865C19.8558 5.02883 19.7821 5 19.6923 5H16.7885V3.5H19.6923Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumb_down.839b776e7b9a626dde630f14ccfe591a.svg";
export { ForwardRef as ReactComponent };